import React, { useState, useEffect } from 'react'
import { motion, useMotionValue, useTransform, animate } from 'framer-motion';

export default function NumberCount(props) {
    const [countValue, setCountValue] = useState(0);
    const count = useMotionValue(0)
    const rounded = useTransform(count, latest => Math.round(latest));

    useEffect(() => {
        let controls;

        controls = animate(count, parseInt(props.count, 10), { duration: 0.3 });


        return () => {
            if (controls) {
                controls.stop();
            }
        };
    }, [props.count, props.error]);

    useEffect(() => {
        const unsubscribe = rounded.onChange(value => {
            setCountValue(value);
        });

        return unsubscribe;
    }, [rounded]);

    const formattedCount = new Intl.NumberFormat('en-IN').format(rounded.current);

    return (
        <div className='container-horizontal res-gap-32' style={{
            display: 'flex',
            justifyContent: 'space-between',
            width:'min(500px, 100%)',
            margin: 'auto',

        }}>
            <span
                className='fw-medium clr-grey-400 fs-medium'
                style={{
                    textAlign: 'text-align-left',
                    width: '100%'
                }}
            >
                {props.label}
            </span>
            <motion.span
                className='fw-semibold clr-primary-heading fs-large'
                style={{
                    textAlign: 'text-align-left', 
                    width: '100%'
                }}>
                {`₹${formattedCount}`}
            </motion.span>
        </div>
    )
}
